const getFormatPrice = (x) => {

    var num = x.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    return num;
};

export default getFormatPrice;